import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {omit} from "lodash"

import {NO_POSITION} from "@irati-web/geolocation/src/constants/currentLocationButton"
import tracking from "@irati-tracking/perks/perks"

import {StyledMap} from "./styled/LocationsMap"
import LocationMarker from "./LocationMarker"

class LocationsMap extends PureComponent {
  static propTypes = {
    userLocation: PropTypes.shape({
      latLng: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired
      }).isRequired
    }).isRequired,
    isMobile: PropTypes.bool.isRequired,
    locationsData: PropTypes.arrayOf(
      PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
        streetAddress: PropTypes.string,
        city: PropTypes.string,
        postCode: PropTypes.string,
        uuid: PropTypes.string
      })
    ).isRequired,
    selectedLocation: PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired
    }),
    deal: PropTypes.object.isRequired
  }

  static defaultProps = {
    selectedLocation: null
  }

  state = {
    mapCenterLatLng: this.props.userLocation.latLng,
    mapData: [],
    mapBounds: null,
    zoom: null
  }

  prepareMapData = (locations) => {
    return locations.map(({uuid, lat, lng, streetAddress, city, postCode}, index) => ({
      key: uuid,
      uuid,
      lat,
      lng,
      streetAddress,
      city,
      postCode,
      index,
      number: index + 1,
      isActive: false,
      zIndex: 1
    }))
  }

  componentDidMount() {
    this.setMapData()
  }

  componentDidUpdate() {
    this.setMapData()
  }

  omitKeysFromComparison = (location) => {
    return omit(location, ["isActive", "zIndex"])
  }

  didMapDataChange = (newMapData) => {
    const newMapDataComparison = newMapData.map((location) => this.omitKeysFromComparison(location))
    const mapDataComparison = this.state.mapData.map((location) => this.omitKeysFromComparison(location))
    return JSON.stringify(newMapDataComparison) !== JSON.stringify(mapDataComparison)
  }

  setMapData = () => {
    const mapData = this.prepareMapData(this.props.locationsData)
    if (this.didMapDataChange(mapData)) {
      this.setState({mapData}, this.handleLocationPreSelection)
    }
  }

  handleMapDataChanged = (mapCenterLatLng, mapBounds = null) => {
    const newState = {
      mapCenterLatLng: mapCenterLatLng || this.props.userLocation.latLng
    }
    if (mapBounds) {
      newState.mapBounds = [mapBounds.ne.lat, mapBounds.ne.lng, mapBounds.sw.lat, mapBounds.sw.lng]
    }
    this.setState(newState)
  }

  handleLocationMarkerClick = (locationUuid) => {
    tracking.clickPerkNearestLocation(this.props.deal)
    this.updateLocationSelection(locationUuid)
  }

  handleMapClick = () => {
    this.updateLocationSelection()
  }

  updateLocationSelection = (locationUuid = null) => {
    const mapData = this.state.mapData.map((location) => {
      const locationCopy = Object.assign({}, location)
      const isMatch = locationCopy.uuid === locationUuid
      locationCopy.isActive = isMatch
      locationCopy.zIndex = isMatch ? 2 : 1
      return locationCopy
    })

    this.setState({
      mapData
    })
  }

  handleLocationPreSelection = () => {
    const {selectedLocation} = this.props
    if (selectedLocation) {
      this.updateLocationSelection(selectedLocation.uuid)
    }
  }

  render() {
    const {userLocation, isMobile} = this.props
    const {mapData, mapCenterLatLng, mapBounds, zoom} = this.state
    const settings = {
      currentLocationButtonPositionMode: NO_POSITION,
      minClusterZoom: 100,
      maxClusterZoom: 100
    }
    if (zoom) { settings.zoom = zoom }

    if (!mapData) { return null }
    return (
      <StyledMap
        fitBounds
        userLatLng={userLocation.latLng}
        centerLatLng={mapCenterLatLng}
        data={mapData}
        onDataChanged={this.handleMapDataChanged}
        onClick={this.handleMapClick}
        LocationMarker={(props) => (
          <LocationMarker
            {...props}
            boundingBox={mapBounds}
            onClick={this.handleLocationMarkerClick} />
        )}
        googleMapsOptions={{
          clickableIcons: false,
          zoomControl: !isMobile,
          fullscreenControl: false,
          maxZoom: 17
        }}
        settings={settings} />
    )
  }
}

const mapStateToProps = ({geoLocation, mq}) => ({userLocation: geoLocation.userLocation, isMobile: mq.lessThan.large})

export default connect(mapStateToProps)(LocationsMap)
